import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/Footer.jsx";
import { useTranslation } from 'react-i18next';
import Footerr from 'components/footers/Footer';
import NotificationBell from 'components/NotificationBell';

const DashbordAdmin = () => {
        const { t } = useTranslation();

    const [orders, setOrders] = useState([]);
    const [orderStats, setOrderStats] = useState({
        total: 0,
        pending: 0,
        completed: 0,
        delivered: 0,
        cancelled: 0,
        refunded: 0,
        pendingPayment: 0,
        totalRevenue: 0,
    });
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        checkAdminStatus();
    }, []);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);
        if (isAdmin) {
            fetchAllOrders();
        } else {
                return;
        }
    };

    const fetchAllOrders = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            const response = await axios.get('  https://rehabwmg.online/api/admin/ordersDashbord', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const or = response.data;
                setOrders(or);
                calculateOrderStats(or);
            } else {
                return;
            }
        } catch (error) {
                return;
        }
    };

    const calculateOrderStats = (orders) => {
        const stats = {
            total: 0,
            pending: 0,
            completed: 0,
            delivered: 0,
            cancelled: 0,
            refunded: 0,
            pendingPayment: 0,
            totalRevenue: 0,
        };
    
        // Iterate over the orders to calculate stats
        orders.forEach((order) => {
            stats.total += 1;
            // Check the status of the order
            switch (order.status) {
                case 'en attente':
                    stats.pending += 1;
                    break;
                case 'attribué':
                    break; // You can decide if you want to count this for any specific case
                case 'en transit':
                    break; // You can decide if you want to count this for any specific case
                case 'livré':
                    stats.delivered += 1;
                    break;
                case 'annulé':
                    stats.cancelled += 1;
                    break;
                default:
                    break;
            }
            if (order.payment.PaymentStatus === 'en attente') {
                stats.pendingPayment += 1;
            }
            if (order.payment.PaymentStatus === 'payé') {
                stats.completed += 1;
            }
    
            // Calculate total revenue (you might want to sum this for each order)
            stats.totalRevenue += parseFloat(order.payment.Amount);
        });
    
        // Set the order stats state
        setOrderStats(stats);
    };
   

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }

    return (
        <AnimationRevealPage>
            <LightAdmin />
                              <NotificationBell />

            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        {/* <h1 className="text-dark display-4">Admin Dashboard</h1> */}
                    </div>
                    <hr className="my-4" />

                    {/* Order Statistics Cards */}
                    <div className="row">
                    <div className="col-md-4 mb-3">
                    <div className="card text-white p-3 shadow" style={{ backgroundColor: '#7AA95C' }}>
                    <div className="card-body">
            <h6 className="card-title">{t('Total_des_Commandes')}</h6>
            <p className="card-text fs-3">{orderStats.total}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
<div className="card text-white p-3 shadow" style={{ backgroundColor: '#5D7052' }}>
<div className="card-body">
            <h6 className="card-title">{t('Total_des_Commandes_Payees')}</h6>
            <p className="card-text fs-3">{orderStats.completed}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
<div className="card text-white p-3 shadow" style={{ backgroundColor: '#226D68' }}>
<div className="card-body">
            <h6 className="card-title">{t('Commandes_Livrees')}</h6>
            <p className="card-text fs-3">{orderStats.delivered}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
<div className="card text-white p-3 shadow" style={{ backgroundColor: '#67944C' }}>
<div className="card-body">
            <h6 className="card-title">{t('Commandes_Annulees')}</h6>
            <p className="card-text fs-3">{orderStats.cancelled}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
<div className="card text-white p-3 shadow" style={{ backgroundColor: '#4B5943' }}>
<div className="card-body">
            <h6 className="card-title">{t('Commandes_en_attente_de_Livraison')}</h6>
            <p className="card-text fs-3">{orderStats.pending}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
<div className="card text-white p-3 shadow" style={{ backgroundColor: '#ACC1AE' }}>
<div className="card-body">
            <h6 className="card-title">{t('Commandes_en_attente_de_Paiement')}</h6>
            <p className="card-text fs-3">{orderStats.pendingPayment}</p>
        </div>
    </div>
</div>

                    </div>
                </section>
            </div>
            <Footerr />
        </AnimationRevealPage>
    );
};

export default DashbordAdmin;
